import { defineComponent as _defineComponent } from 'vue';
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "!mt-10 flex flex-col gap-10 lg:mt-20 lg:gap-20" };
const _hoisted_2 = {
    key: 0,
    class: "container"
};
const _hoisted_3 = { class: "wysiwyg w-full lg:w-2/3" };
const _hoisted_4 = { "data-archive-careers": "" };
const _hoisted_5 = { class: "container flex flex-col gap-10 lg:gap-20" };
const _hoisted_6 = {
    key: 0,
    class: "grid-layout"
};
const _hoisted_7 = {
    key: 1,
    class: "text-center"
};
const _hoisted_8 = { "data-quicklinks": "" };
import { defineAsyncComponent } from 'vue';
import PostCard from '@atoms/PostCard.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArchiveJobs',
    props: {
        posts: {
            type: Object,
            required: false,
        },
        pagination: {
            type: Object,
            required: false,
        },
        quickLinksSections: {
            type: Object,
            required: false,
        },
        intro: {
            type: String,
            required: true,
        },
    },
    setup(__props) {
        const ArchivePagination = defineAsyncComponent(() => import('@molecules/ArchivePagination.vue'));
        const QuickLinks = defineAsyncComponent(() => import('@molecules/QuickLinks.vue'));
        return (_ctx, _cache) => {
            const _directive_dompurify_html = _resolveDirective("dompurify-html");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("section", _hoisted_1, [
                    (__props.intro)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
                                [_directive_dompurify_html, __props.intro]
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("section", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        (__props.posts.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.posts, (post) => {
                                    return (_openBlock(), _createBlock(PostCard, {
                                        post: post,
                                        class: "!opacity-100"
                                    }, null, 8, ["post"]));
                                }), 256))
                            ]))
                            : (_openBlock(), _createElementBlock("h3", _hoisted_7, " Sorry, there are no posts to display for your filter selection. Please try another. ")),
                        (__props.pagination.pages.length > 1)
                            ? (_openBlock(), _createBlock(_unref(ArchivePagination), {
                                key: 2,
                                pagination: __props.pagination
                            }, null, 8, ["pagination"]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (__props.quickLinksSections)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.quickLinksSections, (quickLinks) => {
                        return (_openBlock(), _createElementBlock("section", _hoisted_8, [
                            _createVNode(_unref(QuickLinks), { quickLinks: quickLinks }, null, 8, ["quickLinks"])
                        ]));
                    }), 256))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
